const steps = [
  {
    number: '01',
    title: 'Define tokens',
    description:
      'Configure your design tokens in JSON. Colors, spacing, typography — all in one place.',
    code: 'tokens.json',
  },
  {
    number: '02',
    title: 'Generate Dart tokens + use components',
    description:
      'Run the generator to create type-safe Dart APIs. Import and use the pre-built components.',
    code: 'flutter pub run garmisch:generate',
  },
  {
    number: '03',
    title: 'Keep AI-generated UI consistent',
    description:
      'Instruct AI agents to use tokens and components. No raw values, no design drift.',
    code: '"Use GSpacing.md for margins"',
  },
]

export function HowItWorks() {
  return (
    <section className="bg-white py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        {/* Section Title */}
        <h2 className="mb-4 text-center font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
          How teams use Garmisch
        </h2>
        <p className="mx-auto mb-16 max-w-2xl text-center text-gray-500 dark:text-white/60">
          Three steps to consistent Flutter UI.
        </p>

        {/* Steps */}
        <div className="grid gap-8 md:grid-cols-3">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {/* Connector Line (hidden on mobile, shown between cards on desktop) */}
              {i < steps.length - 1 && (
                <div className="absolute right-0 top-12 hidden h-px w-8 translate-x-full bg-gradient-to-r from-gray-200 to-transparent dark:from-white/20 md:block" />
              )}

              <div className="flex h-full flex-col rounded-2xl border border-gray-200 bg-gray-50 p-6 dark:border-white/10 dark:bg-[#111113]">
                {/* Step Number */}
                <span className="mb-4 font-mono text-3xl font-bold text-[#448AFF]/30">
                  {step.number}
                </span>

                {/* Title */}
                <h3 className="mb-3 text-lg font-semibold text-gray-900 dark:text-white">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="mb-6 flex-grow text-sm leading-relaxed text-gray-500 dark:text-white/60">
                  {step.description}
                </p>

                {/* Code Snippet */}
                <div className="rounded-lg bg-white px-4 py-2 dark:bg-white/5">
                  <code className="font-mono text-xs text-gray-600 dark:text-white/70">
                    {step.code}
                  </code>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
